<template>
	<!-- 更新时间：2026-05-31 -->
	<!-- 功能说明：底部导航菜单配置组件，对应父组件 bottomMenu 数组 -->
	<div class="card">
		<div class="card-title">1. 底部导航菜单配置</div>
		
		<div v-for="(item, i) in value" :key="i" class="row">
			<div class="label">菜单{{ i+1 }}</div>
			<div style="position:relative;width:120px;">
			  <input 
			    v-model="item.name" 
			    placeholder="菜单名称" 
			    style="width:100%;padding-right:28px;box-sizing:border-box"  
			    :disabled="vimSave"
			    maxlength="6"
			  />
			  <span 
			    style="
			      position:absolute;
			      right:6px;
			      top:50%;
			      transform:translateY(-50%);
			      font-size:12px;
			      color:#999;
			      pointer-events:none;
			    "
			  ><span style="color: #2b85e4;">{{ item.name?.length || 0 }}</span>/6</span>
			</div>

			<!-- 选中图标 -->
			<div class="icon-group">
				<img :src="iconUrlMap[`${i}_on`]" class="icon-preview" />
				<label class="upload-btn">
					上传图标
					<input type="file" hidden accept="image/*" @change="selectIcon(i, 'on', $event)" :disabled="vimSave" />
				</label>
				<button @click="resetIcon(i, 'on')" class="reset-btn" :disabled="vimSave">重置</button>
			</div>

			<!-- 未选中图标 -->
			<div class="icon-group">
				<img :src="iconUrlMap[`${i}_off`]" class="icon-preview" />
				<label class="upload-btn">
					上传图标
					<input type="file" hidden accept="image/*" @change="selectIcon(i, 'off', $event)" :disabled="vimSave" />
				</label>
				<button @click="resetIcon(i, 'off')" class="reset-btn" :disabled="vimSave">重置</button>
			</div>

			<label><input v-model="item.stu" type="checkbox" :disabled="vimSave" />学生可见</label>
			<label><input v-model="item.tea" type="checkbox" :disabled="vimSave" />老师可见</label>
			<label><input v-model="item.audience" type="checkbox" :disabled="vimSave" />观课可见</label>
		</div>
	</div>
</template>

<script>
import { fileToBase64 } from '@/js/img.js'
import {
		bottomMenu,
		defaultConfig
	} from "@/js/calssComponets.js"
export default {
	props: {
		// 接收父组件 config.bottomMenu 数组
		value: {
			type: Array,
			default: () => []
		},
		vimSave:{
			type: Boolean,
			default:false,
		}
	},
	data() {
		return {
			// 图标地址缓存，解决异步OSS渲染问题
			iconUrlMap: {},
			bottomMenuList:[],
		}
	},
	watch: {
		// 监听数据源变化，重新解析所有图标
		value: {
			handler() {
				this.resolveAllIconUrl()
			},
			immediate: true,
			deep: true
		}
	},
	created() {
		this.bottomMenuList=bottomMenu()
		console.log('this.bottomMenuList',this.bottomMenuList)
		
	},
	
	methods: {
		// 批量解析所有图标（本地/Base64/OSS-HTTPS）
		async resolveAllIconUrl() {
			const map = {}
			for (let i = 0; i < this.value.length; i++) {
				const item = this.value[i]
				// 解析 iconOn
				map[`${i}_on`] = await this.getFinalIconUrl(item.iconOn, i, 'iconOn')
				// 解析 iconOff
				map[`${i}_off`] = await this.getFinalIconUrl(item.iconOff, i, 'iconOff')
			}
			this.iconUrlMap = map
		},

		// 核心：根据图标内容判断返回最终展示地址
		async getFinalIconUrl(iconStr, index, type) {
			// 1. 为空：使用当前索引对应的默认本地图标
			if (!iconStr) {
				return this.bottomMenuList[index][type] || ''
			}
			if (iconStr.startsWith('@/')) {
				return this.bottomMenuList[index][type] || ''
			}
			// 2. HTTPS 链接：调用OSS解析
			if (iconStr.startsWith('https:')) {
				return await this.$oss.getUrl(iconStr)
			}
			// 3. Base64 / 已有正常地址：直接返回
			return iconStr
		},

		// 上传图标，转为Base64更新父组件数据
		async selectIcon(index, type, e) {
			const file = e.target.files[0]
			if (!file) return
			const base64 = await fileToBase64(file)
			const key = type === 'on' ? 'iconOn' : 'iconOff'

			// 深拷贝数组，不直接修改props
			const newValue = [...this.value]
			newValue[index][key] = base64
			this.$emit('input', newValue)

			// 清空file，防止同文件重复选择不触发change
			e.target.value = ''
		},

		// 重置图标：置空，自动走默认本地图标
		resetIcon(index, type) {
			const key = type === 'on' ? 'iconOn' : 'iconOff'
			const newValue = [...this.value]
			console.log(key,'index',index)
			var ico=this.bottomMenuList[index][key]
			
			newValue[index][key] = ico
			this.$emit('input', newValue)
		}
	}
}
</script>

<style scoped>
.card {
	background: #fff;
	border-radius: 12px;
	padding: 16px;
	margin-bottom: 16px;
	box-shadow: 0 2px 8px #00000010;
}

.card-title {
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 12px;
	color: #333;
}

.row {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 10px;
	flex-wrap: wrap;
}

.label {
	width: 70px;
	font-size: 14px;
	color: #666;
}

input {
	padding: 6px 10px;
	border: 1px solid #ddd;
	border-radius: 6px;
}

.icon-group {
	display: flex;
	align-items: center;
	gap: 6px;
}

.icon-preview {
	width: 28px;
	height: 28px;
	object-fit: contain;
	border: 1px solid #eee;
	border-radius: 4px;
}

.upload-btn {
	padding: 4px 10px;
	background: #e8f3ff;
	color: #2b85e4;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	border: 1px solid #b3d8ff;
}

.upload-btn:hover {
	background: #d7efff;
}

.reset-btn {
	padding: 4px 8px;
	background: #f5f5f5;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
}
</style>